import { get } from 'lodash';

export const ROOT = 'notifications';

export const getByAdomOid =
  (adomOid = -1) =>
  (state) => {
    return get(state, [ROOT, adomOid]);
  };
